import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { PERKS_ADMIN_SLICE_NAME } from "./perksAdmin.constants"

/* ------------- Table ------------- */

export const getPerksAdmin = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/get_perks_admin`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getPerksAdmin(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Had `withoutErrorNotification` in the saga: the filter bar falls back to the partner names
// already present in the loaded rows (see the slice's `rejected` case), so a failure here is
// recoverable and must not raise a toast of its own.
export const getPerksAdminFilterOptions = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/get_perks_admin_filter_options`,
  async (_, { rejectWithValue }) => {
    const response = await services.getPerksAdminFilterOptions()
    if (!response.ok) return rejectWithValue(response.data)
    return response.data
  }
)

/* ------------- Perk CRUD ------------- */

export const createPerkAdmin = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/create_perk_admin`,
  async (formData, { dispatch, rejectWithValue }) => {
    const response = await services.createPerkAdmin(formData)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updatePerkAdmin = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/update_perk_admin`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updatePerkAdmin(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const deletePerkAdmin = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/delete_perk_admin`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.deletePerkAdmin(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const togglePerkVisibility = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/toggle_perk_visibility`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.togglePerkVisibility(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Card order ------------- */

export const getPerksManageOrder = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/get_perks_manage_order`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getPerksManageOrder()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const reorderPerks = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/reorder_perks`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.reorderPerks(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Comments ------------- */

export const savePerkComment = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/save_perk_comment`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.savePerkComment(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const deletePerkComment = createAsyncThunk(
  `${PERKS_ADMIN_SLICE_NAME}/delete_perk_comment`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.deletePerkComment(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
